import styled from 'styled-components';
import Screen from '../../../../shared/utils/screen';
import DeviceConfig from '@devices/config';
import withImage from '../../../../shared/components/utils/hoc/withImage';

const DetailAddonBackground = styled.img<React.CSSProperties>`
  position: fixed;
  width: 100%;
  height: ${Screen.widthRatio * 715}px;
  object-fit: ${() =>
    DeviceConfig.capabilities.image.disableFitCover ? 'unset' : 'cover'};
`;

export default withImage(DetailAddonBackground);
